module.exports = __webpack_public_path__ + "img/cloth_g1_pants_01.d014b72b.svg";